
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/practice-areas/adoption",
      function () {
        return require("private-next-pages/practice-areas/adoption/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/practice-areas/adoption"])
      });
    }
  